export default "__VITE_ASSET__N6NWZ0$w__"